import React from "react";
import Form from 'react-bootstrap/Form';
import { Badge, Table } from 'react-bootstrap';

export default function SubmittedProgramsTable(props) {
    return (
        <div>
            <Table>
                <thead>
                    <tr>
                        <th>Programs</th>
                        <th></th>
                        <th>Programs to work on</th>
                    </tr>
                </thead>
                <tbody>
                    { props.submittedPrograms &&
                        props.submittedPrograms.map((program,key) =>
                            <tr key={key}>
                                <td>{program.name}</td>
                                <td>
                                    {program.status === 'in-progress' &&
                                        <Badge bg="primary" text="light">In-Progress</Badge>
                                    }
                                    {program.status === 'completed' &&
                                        <Badge bg="success" text="light">Completed</Badge>
                                    }
                                </td>
                                <td className="mx-auto text-left">
                                    <Form.Select
                                        onChange={props.onProgramChanged}
                                        name={program.programId}
                                        aria-label="Is program assessment included in report?"
                                        >
                                        <option value="no">No</option>
                                        <option value="yes">Yes</option>
                                    </Form.Select>
                                </td>
                            </tr>
                        )
                    }
                </tbody>
            </Table>
        </div>
    )
}